import {Typography, styled} from '@mui/material'
import 'assets/css/fonts.css'

const RegularText = styled(Typography)(({theme}) => ({
    color: theme.palette.text.secondary,
}))

const MediumText = styled('span')`
    font-weight: 500;
`

const BoldText = styled('span')`
    font-weight: bold;
`

const Title = styled(BoldText)(({theme}) => ({
    color: theme.palette.primary.main,
    fontSize: 24,
}))

const Subtitle = styled(RegularText)(({theme}) => ({
    color: theme.palette.primary.main,
}))

const Text = styled(Typography)``

const Texts = {RegularText, MediumText, Title, BoldText, Text, Subtitle}
export default Texts
